"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventApplyVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class EventApplyVfxStepArgs {
    constructor(eventId) {
        this.eventId = eventId;
        this.__typeName = "EventApply";
        this.id = (0, uuid_1.v4)();
    }
}
exports.EventApplyVfxStepArgs = EventApplyVfxStepArgs;
